namespace Meevo.Components.Controls {
    "use strict";

    export class MeevoPopupTooltip implements angular.IDirective {
        restrict = 'E';
        transclude = true;
        
        scope = {
            iconFile: '<?',
            iconStyle: '<?',
            iconClass: '<?',
            iconClassName: '@?',
            
            tooltipStyle: '<?',
            tooltipClass: '<?',
            tooltipClassName: '@?',
            
            backdropStyle: '<?',
            backdropClass: '<?',
            backdropStyleInline: '@?',

            onOpening: '&?',
            onOpened: '&?',
            onClosing: '&?',
            onClosed: '&?',

            disabled: "=?ngDisabled",

            // Optional two-way binding so a caller can close the popup itself (e.g. before navigating away
            // on a click inside it) or read whether it is open. Callers that don't bind it are unaffected.
            visible: "=?"
        };

        defaults = {
            iconFile: "assets/images/icons/circle_info_button.svg",
            backdropStyleInline: "position:fixed; left:0px; right:0px; top:0px; bottom:0px; width:100vw!important; height:100vh!important;",
        };

        template = `<div>
    <md-icon md-svg-icon="{{ iconFile || defaults.iconFile }}"
        class="{{ iconClassName }}"
        ng-class="iconClass"
        ng-style="iconStyle"
        ng-click="showPopupTooltip()"></md-icon>
    <div style="{{ backdropStyleInline || defaults.backdropStyleInline }}"
        ng-style="backdropStyle"
        ng-class="backdropClass"
        ng-click="hidePopupTooltip()"
        ng-show="visible"></div>
    <div ng-transclude
        class="{{ tooltipClassName }}"
        ng-class="tooltipClass"
        ng-style="tooltipStyle"
        ng-click="$event.stopPropagation()"
        ng-show="visible"></div>
</div>`;

        show = (scope: angular.IScope): void => {
            if (scope.disabled) {
                return;
            }
            if (scope.onOpening) {
                const result = scope.onOpening();
                if (result === false) {
                    return;
                }
            }
            scope.visible = true;
            if (scope.onOpened) {
                scope.onOpened();
            }
        };

        hide = (scope: angular.IScope): void => {
            if (scope.onClosing) {
                const result = scope.onClosing();
                if (result === false) {
                    return;
                }
            }
            scope.visible = false;
            if (scope.onClosed) {
                scope.onClosed();
            }
        };

        link = (scope: angular.IScope, element: JQuery, attr: angular.IAttributes) => {
            scope.defaults = this.defaults;

            // Starts closed even if a caller pre-set the bound variable to true - this directive owns when
            // it opens (via the icon click), the binding is only for closing it from outside.
            scope.visible = false;

            scope.showPopupTooltip = () => this.show(scope);
            scope.hidePopupTooltip = () => this.hide(scope);
        };

        constructor() {
        }

        static factory(): angular.IDirectiveFactory {
            const directive = () => new MeevoPopupTooltip();
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPopupTooltip", MeevoPopupTooltip.factory());
}
